// import React, { useEffect, useMemo, useState } from 'react';
// import { Badge, Card } from 'react-bootstrap';
// import { Button } from 'primereact/button';
// import { Dropdown } from 'primereact/dropdown';
// import { InputText } from 'primereact/inputtext';
// import RoleEditor from './RoleEditor';
// import { formatRoleLabel } from '../../utils/roleLabels';

// const CHIP_LIMIT = 4;

// const ACTION_LABELS = {
//   view: 'View',
//   read: 'View',
//   read_all: 'View all',
//   create: 'Add',
//   write: 'Add, Edit',
//   edit: 'Edit',
//   delete: 'Delete',
// };

// function actionLabel(action) {
//   return ACTION_LABELS[action.id] || action.label;
// }

// export function chipsFor(catalog, keys) {
//   const held = new Set(keys);
//   const chips = [];
//   catalog.modules.forEach((module) => {
//     if (module.baseline) {
//       module.keys.forEach((item) => {
//         if (held.has(item.key)) chips.push({ id: item.key, feature: item.label, actions: ['View'] });
//       });
//       return;
//     }
//     module.rows.forEach((row) => {
//       const actions = [];
//       module.actions.forEach((action) => {
//         const key = row.cells[action.id];
//         if (key && held.has(key)) actions.push(actionLabel(action));
//       });
//       if (actions.length) {
//         chips.push({ id: `${module.id}:${row.label}`, feature: row.label, actions: [...new Set(actions)] });
//       }
//     });
//   });
//   catalog.outsideInventory.forEach((item) => {
//     if (held.has(item.key)) chips.push({ id: item.key, feature: item.label, actions: ['Manage'] });
//   });
//   return chips;
// }

// const RolesPage = ({
//   request,
//   roles,
//   catalog,
//   canManage,
//   actorPermissions,
//   editor,
//   setEditor,
//   reloadRoles,
//   notify,
// }) => {
//   const [keysByRole, setKeysByRole] = useState({});
//   const [sortOrder, setSortOrder] = useState('ASC');
//   const [pageSize, setPageSize] = useState(15);
//   const [page, setPage] = useState(0);
//   const [search, setSearch] = useState('');
//   const [expanded, setExpanded] = useState({});

//   useEffect(() => {
//     let cancelled = false;
//     Promise.all(roles.map((role) => (
//       request(`/roles/${encodeURIComponent(role.roleName)}/permissions`)
//         .then((data) => [role.roleName, data.permissionKeys || []])
//         .catch(() => [role.roleName, []])
//     ))).then((entries) => {
//       if (!cancelled) setKeysByRole(Object.fromEntries(entries));
//     });
//     return () => { cancelled = true; };
//   }, [roles, request]);

//   const visibleRoles = useMemo(() => {
//     const term = search.trim().toLowerCase();
//     const filtered = roles.filter((role) => (
//       !term
//       || role.roleName.toLowerCase().includes(term)
//       || formatRoleLabel(role.roleName).toLowerCase().includes(term)
//       || (role.description || '').toLowerCase().includes(term)
//     ));
//     filtered.sort((a, b) => (
//       sortOrder === 'ASC' ? a.roleName.localeCompare(b.roleName) : b.roleName.localeCompare(a.roleName)
//     ));
//     return filtered;
//   }, [roles, search, sortOrder]);

//   const pageCount = Math.max(1, Math.ceil(visibleRoles.length / pageSize));
//   const currentPage = Math.min(page, pageCount - 1);
//   const pageRoles = visibleRoles.slice(currentPage * pageSize, (currentPage + 1) * pageSize);

//   if (editor) {
//     return (
//       <RoleEditor
//         request={request}
//         editor={editor}
//         roles={roles}
//         catalog={catalog}
//         canManage={canManage}
//         actorPermissions={actorPermissions}
//         initialKeys={editor.role ? keysByRole[editor.role.roleName] : null}
//         onClose={() => setEditor(null)}
//         onSaved={async (message) => {
//           setEditor(null);
//           notify('success', message);
//           await reloadRoles();
//         }}
//         notify={notify}
//       />
//     );
//   }

//   return (
//     <Card className="iam-roles-card mb-4">
//       <Card.Body>
//         <div className="iam-toolbar">
//           <span className="iam-toolbar-label">Sort By</span>
//           <Dropdown
//             value={sortOrder}
//             options={[{ label: 'ASC', value: 'ASC' }, { label: 'DESC', value: 'DESC' }]}
//             onChange={(event) => setSortOrder(event.value)}
//             className="iam-sort-dropdown"
//             panelClassName="iam-dropdown-panel"
//             aria-label="Sort roles"
//           />
//           <Dropdown
//             value={pageSize}
//             options={[15, 30, 50].map((size) => ({ label: String(size), value: size }))}
//             onChange={(event) => { setPageSize(event.value); setPage(0); }}
//             className="iam-pagesize-dropdown"
//             panelClassName="iam-dropdown-panel"
//             aria-label="Roles per page"
//           />
//           <div className="iam-search">
//             <i className="pi pi-search iam-search-icon" />
//             <InputText
//               className="iam-search-input"
//               value={search}
//               placeholder="Search roles"
//               onChange={(event) => { setSearch(event.target.value); setPage(0); }}
//             />
//           </div>
//         </div>

//         <div className="table-responsive">
//           <table className="iam-roles-table">
//             <thead>
//               <tr>
//                 <th>Role Name</th>
//                 <th>Permissions</th>
//                 <th>Description</th>
//                 <th className="text-center">Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {pageRoles.map((role) => {
//                 const chips = chipsFor(catalog, keysByRole[role.roleName] || []);
//                 const open = Boolean(expanded[role.roleName]);
//                 const shown = open ? chips : chips.slice(0, CHIP_LIMIT);
//                 return (
//                   <tr key={role.roleName}>
//                     <td className="iam-role-name">
//                       <div>
//                         {formatRoleLabel(role.roleName)}{' '}
//                         {role.isSystem && <Badge bg="secondary">System</Badge>}
//                       </div>
//                       <small className="text-muted">
//                         Users: {role.userCount}
//                       </small>
//                     </td>
//                     <td>
//                       <div className="iam-chips">
//                         {shown.map((chip) => (
//                           <div className="iam-chip" key={chip.id}>
//                             <div className="iam-chip-feature">{chip.feature}</div>
//                             <div className="iam-chip-actions">{chip.actions.join(', ')}</div>
//                           </div>
//                         ))}
//                         {chips.length > CHIP_LIMIT && (
//                           <button
//                             type="button"
//                             className="iam-chip iam-chip-more"
//                             onClick={() => setExpanded((current) => ({ ...current, [role.roleName]: !open }))}
//                           >
//                             {open ? 'Less...' : 'More...'}
//                           </button>
//                         )}
//                         {!chips.length && <span className="text-muted">No permissions</span>}
//                       </div>
//                     </td>
//                     <td className="iam-role-description">{role.description}</td>
//                     <td className="text-center">
//                       {role.isSystem ? (
//                         <Button
//                           icon="pi pi-eye"
//                           text
//                           rounded
//                           className="iam-role-view"
//                           aria-label="System role: view only"
//                           tooltip="System role: view only"
//                           tooltipOptions={{ position: 'left' }}
//                           onClick={() => setEditor({ mode: 'view', role })}
//                         />
//                       ) : (
//                         <Button
//                           icon="pi pi-pencil"
//                           text
//                           rounded
//                           severity="help"
//                           aria-label={`Edit ${formatRoleLabel(role.roleName)}`}
//                           disabled={!canManage}
//                           onClick={() => setEditor({ mode: 'edit', role })}
//                         />
//                       )}
//                     </td>
//                   </tr>
//                 );
//               })}
//               {!pageRoles.length && (
//                 <tr>
//                   <td colSpan={4} className="text-center text-muted py-4">No roles match this search.</td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>

//         {pageCount > 1 && (
//           <div className="iam-pager">
//             <Button
//               icon="pi pi-angle-left"
//               text
//               disabled={currentPage === 0}
//               onClick={() => setPage(currentPage - 1)}
//               aria-label="Previous page"
//             />
//             <span>{currentPage + 1} / {pageCount}</span>
//             <Button
//               icon="pi pi-angle-right"
//               text
//               disabled={currentPage >= pageCount - 1}
//               onClick={() => setPage(currentPage + 1)}
//               aria-label="Next page"
//             />
//           </div>
//         )}
//       </Card.Body>
//     </Card>
//   );
// };

// export default RolesPage;


import React, { useEffect, useMemo, useState } from 'react';
import { Card } from 'react-bootstrap';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import RoleEditor from './RoleEditor';
import { formatRoleLabel } from '../../utils/roleLabels';
import { roleTone } from './roleTone';

const MODULE_PILL_LIMIT = 3;

const SORT_OPTIONS = [
  { label: 'Name A–Z', value: 'ASC' },
  { label: 'Name Z–A', value: 'DESC' },
];

const PAGE_SIZE_OPTIONS = [15, 30, 50].map((size) => ({ label: `${size} per page`, value: size }));

const ACTION_LABELS = {
  view: 'View',
  read: 'View',
  read_all: 'View all',
  create: 'Add',
  write: 'Add, Edit',
  edit: 'Edit',
  delete: 'Delete',
};

/* Each kind of action gets its own colour so a row can be read at a glance. */
const ACTION_TONES = {
  View: 'slate',
  'View all': 'sky',
  Add: 'emerald',
  Edit: 'amber',
  Delete: 'rose',
  Manage: 'indigo',
};

function actionTone(label) {
  return ACTION_TONES[label] || 'slate';
}

function actionLabel(action) {
  return ACTION_LABELS[action.id] || action.label;
}

/* "Add, Edit" is one catalog action but reads better as two tags. */
function splitActions(label) {
  return String(label).split(',').map((part) => part.trim()).filter(Boolean);
}

/* Kept for RoleEditor and anything else importing it — unchanged behaviour. */
export function chipsFor(catalog, keys) {
  const held = new Set(keys);
  const chips = [];
  catalog.modules.forEach((module) => {
    if (module.baseline) {
      module.keys.forEach((item) => {
        if (held.has(item.key)) chips.push({ id: item.key, feature: item.label, actions: ['View'] });
      });
      return;
    }
    module.rows.forEach((row) => {
      const actions = [];
      module.actions.forEach((action) => {
        const key = row.cells[action.id];
        if (key && held.has(key)) actions.push(actionLabel(action));
      });
      if (actions.length) {
        chips.push({ id: `${module.id}:${row.label}`, feature: row.label, actions: [...new Set(actions)] });
      }
    });
  });
  catalog.outsideInventory.forEach((item) => {
    if (held.has(item.key)) chips.push({ id: item.key, feature: item.label, actions: ['Manage'] });
  });
  return chips;
}

/* Same data as chipsFor, but kept grouped by module so the table can show
   module → feature → actions instead of one long flat list of chips. */
export function groupsFor(catalog, keys) {
  const held = new Set(keys);
  const groups = [];

  (catalog.modules || []).forEach((module) => {
    const items = [];

    if (module.baseline) {
      (module.keys || []).forEach((item) => {
        if (held.has(item.key)) items.push({ id: item.key, feature: item.label, actions: ['View'] });
      });
    } else {
      (module.rows || []).forEach((row) => {
        const actions = [];
        (module.actions || []).forEach((action) => {
          const key = row.cells[action.id];
          if (key && held.has(key)) splitActions(actionLabel(action)).forEach((part) => actions.push(part));
        });
        if (actions.length) {
          items.push({ id: `${module.id}:${row.label}`, feature: row.label, actions: [...new Set(actions)] });
        }
      });
    }

    if (items.length) groups.push({ id: module.id, title: module.title, items });
  });

  const outside = [];
  (catalog.outsideInventory || []).forEach((item) => {
    if (held.has(item.key)) outside.push({ id: item.key, feature: item.label, actions: ['Manage'] });
  });
  if (outside.length) groups.push({ id: '__outside', title: 'Other access', items: outside });

  return groups;
}

const RolesPage = ({
  request,
  roles,
  catalog,
  canManage,
  actorPermissions,
  editor,
  setEditor,
  reloadRoles,
  notify,
}) => {
  const [keysByRole, setKeysByRole] = useState({});
  const [loadingKeys, setLoadingKeys] = useState(true);
  const [sortOrder, setSortOrder] = useState('ASC');
  const [pageSize, setPageSize] = useState(15);
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState('');
  const [expanded, setExpanded] = useState({});

  useEffect(() => {
    let cancelled = false;
    setLoadingKeys(true);
    Promise.all(roles.map((role) => (
      request(`/roles/${encodeURIComponent(role.roleName)}/permissions`)
        .then((data) => [role.roleName, data.permissionKeys || []])
        .catch(() => [role.roleName, []])
    ))).then((entries) => {
      if (cancelled) return;
      setKeysByRole(Object.fromEntries(entries));
      setLoadingKeys(false);
    });
    return () => { cancelled = true; };
  }, [roles, request]);

  const visibleRoles = useMemo(() => {
    const term = search.trim().toLowerCase();
    const filtered = roles.filter((role) => (
      !term
      || role.roleName.toLowerCase().includes(term)
      || formatRoleLabel(role.roleName).toLowerCase().includes(term)
      || (role.description || '').toLowerCase().includes(term)
    ));
    filtered.sort((a, b) => (
      sortOrder === 'ASC' ? a.roleName.localeCompare(b.roleName) : b.roleName.localeCompare(a.roleName)
    ));
    return filtered;
  }, [roles, search, sortOrder]);

  const pageCount = Math.max(1, Math.ceil(visibleRoles.length / pageSize));
  const currentPage = Math.min(page, pageCount - 1);
  const pageRoles = visibleRoles.slice(currentPage * pageSize, (currentPage + 1) * pageSize);
  const firstRow = visibleRoles.length ? currentPage * pageSize + 1 : 0;
  const lastRow = Math.min((currentPage + 1) * pageSize, visibleRoles.length);

  const toggleRole = (roleName) => setExpanded((current) => ({
    ...current,
    [roleName]: !current[roleName],
  }));

  if (editor) {
    return (
      <RoleEditor
        request={request}
        editor={editor}
        roles={roles}
        catalog={catalog}
        canManage={canManage}
        actorPermissions={actorPermissions}
        initialKeys={editor.role ? keysByRole[editor.role.roleName] : null}
        onClose={() => setEditor(null)}
        onSaved={async (message) => {
          setEditor(null);
          notify('success', message);
          await reloadRoles();
        }}
        notify={notify}
      />
    );
  }

  const permissionsCell = (role) => {
    const groups = groupsFor(catalog, keysByRole[role.roleName] || []);
    const totalPermissions = groups.reduce((sum, group) => sum + group.items.length, 0);
    const open = Boolean(expanded[role.roleName]);

    if (loadingKeys && !totalPermissions) {
      return <span className="iam-perm-loading">Loading permissions…</span>;
    }

    if (!totalPermissions) {
      return (
        <span className="iam-perm-none">
          <i className="pi pi-minus-circle" aria-hidden="true" /> No permissions
        </span>
      );
    }

    return (
      <div className="iam-perms">
        <button
          type="button"
          className={`iam-perm-toggle${open ? ' is-open' : ''}`}
          aria-expanded={open}
          onClick={() => toggleRole(role.roleName)}
        >
          <i className="pi pi-chevron-down" aria-hidden="true" />
          <span>
            {totalPermissions} {totalPermissions === 1 ? 'permission' : 'permissions'}
            {' · '}
            {groups.length} {groups.length === 1 ? 'module' : 'modules'}
          </span>
        </button>

        {!open && (
          <div className="iam-mod-pills">
            {groups.slice(0, MODULE_PILL_LIMIT).map((group) => (
              <span className="iam-mod-pill" key={group.id}>
                {group.title}
                <span className="iam-mod-count">{group.items.length}</span>
              </span>
            ))}
            {groups.length > MODULE_PILL_LIMIT && (
              <span className="iam-mod-pill is-rest">+{groups.length - MODULE_PILL_LIMIT} more</span>
            )}
          </div>
        )}

        {open && (
          <div className="iam-perm-groups">
            {groups.map((group) => (
              <div className="iam-perm-group" key={group.id}>
                <div className="iam-perm-group-title">
                  {group.title}
                  <span className="iam-mod-count">{group.items.length}</span>
                </div>
                <ul className="iam-perm-rows">
                  {group.items.map((item) => (
                    <li key={item.id}>
                      <span className="iam-perm-feature">{item.feature}</span>
                      <span className="iam-action-tags">
                        {item.actions.map((action) => (
                          <span className={`iam-action-tag tone-${actionTone(action)}`} key={action}>
                            {action}
                          </span>
                        ))}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  return (
    <Card className="iam-card iam-roles-card">
      <Card.Body className="p-0">
        {/* search | sort | page size on one line */}
        <div className="iam-roles-toolbar">
          <div className="iam-search">
            <i className="pi pi-search iam-search-icon" aria-hidden="true" />
            <InputText
              className="iam-search-input"
              value={search}
              placeholder="Search roles"
              aria-label="Search roles"
              onChange={(event) => { setSearch(event.target.value); setPage(0); }}
            />
            {search && (
              <button
                type="button"
                className="iam-search-clear"
                aria-label="Clear search"
                onClick={() => { setSearch(''); setPage(0); }}
              >
                <i className="pi pi-times" />
              </button>
            )}
          </div>

          <Dropdown
            value={sortOrder}
            options={SORT_OPTIONS}
            onChange={(event) => setSortOrder(event.value)}
            className="iam-filter-dropdown"
            panelClassName="iam-dropdown-panel"
            aria-label="Sort roles"
          />
          <Dropdown
            value={pageSize}
            options={PAGE_SIZE_OPTIONS}
            onChange={(event) => { setPageSize(event.value); setPage(0); }}
            className="iam-filter-dropdown"
            panelClassName="iam-dropdown-panel"
            aria-label="Roles per page"
          />
        </div>

        <div className="iam-roles-scroll">
          <table className="iam-roles-grid">
            <thead>
              <tr>
                <th className="col-role">Role</th>
                <th className="col-perms">Permissions</th>
                <th className="col-desc">Description</th>
                <th className="col-action">Action</th>
              </tr>
            </thead>
            <tbody>
              {pageRoles.map((role) => (
                <tr key={role.roleName}>
                  <td className="col-role">
                    <div className="iam-role-head">
                      <span className={`iam-role-dot tone-${roleTone(role.roleName)}`} aria-hidden="true" />
                      <span className="iam-role-text">
                        <span className="iam-role-title">
                          {formatRoleLabel(role.roleName)}
                          {role.isSystem && <span className="iam-sys-badge">System</span>}
                        </span>
                        <span className="iam-role-meta">
                          <i className="pi pi-user" aria-hidden="true" />
                          {role.userCount} {Number(role.userCount) === 1 ? 'user' : 'users'}
                        </span>
                      </span>
                    </div>
                  </td>

                  <td className="col-perms">{permissionsCell(role)}</td>

                  <td className="col-desc">
                    <span className="iam-role-desc" title={role.description || ''}>
                      {role.description || '—'}
                    </span>
                  </td>

                  <td className="col-action">
                    {role.isSystem ? (
                      <Button
                        icon="pi pi-eye"
                        text
                        className="iam-action-btn iam-role-view"
                        aria-label={`View ${formatRoleLabel(role.roleName)}`}
                        tooltip="System role: view only"
                        tooltipOptions={{ position: 'left' }}
                        onClick={() => setEditor({ mode: 'view', role })}
                      />
                    ) : (
                      <Button
                        icon="pi pi-pencil"
                        text
                        severity="help"
                        className="iam-action-btn"
                        aria-label={`Edit ${formatRoleLabel(role.roleName)}`}
                        tooltip={canManage ? 'Edit role' : 'You cannot edit roles'}
                        tooltipOptions={{ position: 'left' }}
                        disabled={!canManage}
                        onClick={() => setEditor({ mode: 'edit', role })}
                      />
                    )}
                  </td>
                </tr>
              ))}

              {!pageRoles.length && (
                <tr>
                  <td colSpan={4}>
                    <div className="iam-empty">
                      <i className="pi pi-shield" aria-hidden="true" />
                      <p>{search ? 'No roles match this search.' : 'No roles yet.'}</p>
                      {search && <Button label="Clear search" link size="small" onClick={() => setSearch('')} />}
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="iam-roles-footer">
          <span className="iam-roles-count">
            {firstRow}–{lastRow} of {visibleRoles.length} {visibleRoles.length === 1 ? 'role' : 'roles'}
          </span>
          <div className="iam-pager">
            <Button
              icon="pi pi-angle-left"
              text
              rounded
              disabled={currentPage === 0}
              onClick={() => setPage(currentPage - 1)}
              aria-label="Previous page"
            />
            <span>{currentPage + 1} / {pageCount}</span>
            <Button
              icon="pi pi-angle-right"
              text
              rounded
              disabled={currentPage >= pageCount - 1}
              onClick={() => setPage(currentPage + 1)}
              aria-label="Next page"
            />
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default RolesPage;

